module.exports = "<div class=loader>{{localize 'CORE.FORM.EDITORS.REFERENCE.LOADING'}}</div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/reference/templates/loading.hbs
// module id = 675
// module chunks = 0